// @flow

import React, { type Node } from 'react';

import successIconSrc from './success-icon.svg';

type IconProps = {
  backgroundColor: string;
  borderColor: string;
  size?: string,
  src: string;
}

export function Icon(props: IconProps): Node {
  return (
    <span style={{
      border: `${props.borderColor} 1px solid`,
      borderRadius: '50%',
      display: 'inline-block',
      height: props.size || '1em',
      position: 'relative',
      width: props.size || '1em',
    }}>
      <i style={{
        backgroundColor: props.backgroundColor,
        backgroundImage: `url('${props.src}')`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '50%',
        borderRadius: '50%',
        bottom: '10%',
        left: '10%',
        position: 'absolute',
        right: '10%',
        top: '10%',
      }} />
    </span>
  );
}

type Props = {|
  size?: string,
|};

export const SuccessIcon = (props: Props) => (
  <Icon src={successIconSrc} alt="success icon" borderColor="#2ecc71" backgroundColor="#2ecc71" {...props} />
);
